import { render } from "./Register.vue?vue&type=template&id=c8d33d50"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Desktop/projects/Realgestion/rg-massive-camoruco/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__